import { render, staticRenderFns } from "./IconLogo.vue?vue&type=template&id=409d431e&"
import script from "./IconLogo.vue?vue&type=script&lang=js&"
export * from "./IconLogo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/src/searchie/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('409d431e')) {
      api.createRecord('409d431e', component.options)
    } else {
      api.reload('409d431e', component.options)
    }
    module.hot.accept("./IconLogo.vue?vue&type=template&id=409d431e&", function () {
      api.rerender('409d431e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/icons/IconLogo.vue"
export default component.exports